if (window.location.hostname == "localhost") {
  var apiEndPoint = "http://localhost:4009/";
} else {
  var apiEndPoint = "https://api-exim-crm.pyther.com/";
}
// if (window.location.hostname != 'localhost') {
//     apiEndPoint = "/";
// }

export const apiCurrent = apiEndPoint;
export const userApi = apiEndPoint + "api/users";
export const prospectApi = apiEndPoint + "api/prospects";
export const noteApi = apiEndPoint + "api/notes";
export const labelApi = apiEndPoint + "api/labels";
export const templateApi = apiEndPoint + "api/templates";
export const trackingApi = apiEndPoint + "api/tracking";
export const loginApi = apiEndPoint + "users/authenticate";
export const meApi = apiEndPoint + "api/me";
export const sendMailApi = apiEndPoint + "api/sendemail";
export const sendBulkMailApi = apiEndPoint + "api/sendbulkemail";
export const imagesApi = apiEndPoint + "api/images";
export const closingDeals = apiEndPoint + "api/prospects";
export const uploadCsvApi = apiEndPoint + "api/upload-csv";
// export const uploadCsvApi = apiEndPoint + 'api/upload/csv'
// export const trackMailApi = apiEndPoint + 'api/tk';